import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      common: {
        ...store.getState().i18n.translations.en.common,
        datePicker: {
          RESET: 'Reset',
          CUSTOM_DATE_RANGE: 'Custom Date Ranges',
          INPUT_TYPING_PLACEHOLDER: 'mm/dd/yyyy',
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      common: {
        ...store.getState().i18n.translations.vi.common,
        datePicker: {
          RESET: 'Đặt lại',
          CUSTOM_DATE_RANGE: 'Tùy chỉnh',
          INPUT_TYPING_PLACEHOLDER: 'dd/mm/yyyy',
        },
      },
    },
  }),
)
